function normalizeBase(baseUrl: string): string {
  const trimmed = baseUrl.trim();
  if (!trimmed || trimmed === '/') return '';
  return trimmed.replace(/\/+$/, '');
}

function normalizePath(path: string): string {
  return path.startsWith('/') ? path : `/${path}`;
}

export function gaiaHttpUrl(baseUrl: string, path: string): string {
  const base = normalizeBase(baseUrl);
  return `${base}${normalizePath(path)}`;
}

export function gaiaWebSocketUrl(baseUrl: string, path: string): string {
  const base = normalizeBase(baseUrl);
  const normalizedPath = normalizePath(path);
  if (!base) return sameOriginWebSocketUrl(normalizedPath);

  if (base.startsWith('https://')) return `wss://${base.slice('https://'.length)}${normalizedPath}`;
  if (base.startsWith('http://')) return `ws://${base.slice('http://'.length)}${normalizedPath}`;
  return `${base}${normalizedPath}`;
}

function sameOriginWebSocketUrl(path: string): string {
  if (typeof window === 'undefined') return path;

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}${path}`;
}
